import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-white border-t border-gray-100" data-id="element-92">
      <div className="container mx-auto px-4" data-id="element-93">
        <div className="max-w-4xl mx-auto bg-blue-50 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 border border-blue-100" data-id="element-94">
          <div className="flex-shrink-0" data-id="element-95">
            <ShieldCheck className="w-24 h-24 text-blue-600" data-id="element-96" />
          </div>
          <div className="text-center md:text-left" data-id="element-97">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-98">
              Garantía sin preguntas
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed" data-id="element-99">
              Probalo 7 días sin riesgo. Si no te sirve, te devolvemos el 100%
              de tu dinero. Estamos tan seguros de la calidad de este material
              que asumimos todo el riesgo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}